<template>
    <Collapse
        :id="id"
        v-model="proxyExpand"
    >
        <span slot="label">{{ $t('Search.labels.shortSequence') }}</span>
        <LayoutContainer>
            <LayoutColumn>
                <SectionBlock>
                    <AlignmentIdentityField />
                    <QueryIdentityField />
                    <QueryCoverageField />
                    <SubjectIdentityField />
                    <SubjectCoverageField />
                </SectionBlock>
            </LayoutColumn>
            <LayoutColumn>
                <AlgorithmBlock v-if="!store.algorithmSettingsDisabled" />
            </LayoutColumn>
        </LayoutContainer>
    </Collapse>
</template>

<script>
import BioSearchSettingProvider from '../BioSearchSettingProvider.vue';
import AlgorithmBlock from './Algorithm.prefab.vue';

export default {
    components: { AlgorithmBlock },
    extends: BioSearchSettingProvider,
    inject: {
        state: {
            from: 'state',
            default: null,
        },
    },
    data() {
        return {
            expand: false,
        };
    },
    computed: {
        proxyExpand: {
            get() {
                if (this.state) {
                    return this.state?.shortExpand;
                }
                return this.expand;
            },
            set(val) {
                if (this.state) {
                    this.state.shortExpand = val;
                }
                this.expand = val;
            },
        },
    },
};
</script>
